export function validateQuestion(data: { [key: string]: any }) {
  let error: { [key: string]: string } = {}

  if (!data.content) {
    error.content = 'Không được bỏ trống nội dung câu hỏi'
  }

  return error
}
